<template>
  <customModal :containermd="true" @closeModal="handleClose">
    <template #title>
      <span v-if="documentEdit === false">{{
        $t("navigations.upload document")
      }}</span>
      <span v-else>{{ $t("navigations.edit document") }}</span>
    </template>

    <template #body>
      <!-- Loader only in edit mode when fetching doc -->
      <div class="text-center" v-if="documentEdit && documentLoader">
        <h4>{{ "Please wait while the data is being fetched" }}</h4>
        <img
          src="../../assets/img/loading.gif"
          width="15"
          alt="Waiting for login"
        />
      </div>

      <div v-else>
        <div class="row">
          <div class="col-12 col-md-6 pr-md-1 mt-2">
            <label for="document-title">Document Title</label>
            <input
              id="document-title"
              type="text"
              class="form-control"
              maxlength="75"
              v-model.trim="docTitle"
              placeholder="Enter document title"
            />
          </div>

          <div class="col-12 col-md-6 mt-2">
            <label for="version">Version</label>
            <input
              id="version"
              type="text"
              class="form-control"
              maxlength="10"
              v-model.trim="docVersion"
              :readonly="documentEdit === true"
              placeholder="Enter version"
            />
            <span class="d-block errorClass" v-if="documentValidationsError[0]">
              Please enter a version
            </span>
          </div>

          <div class="col-12 col-md-6 pr-md-1 mt-2">
            <label for="documentOwner">Select Owner</label>
            <select
              id="documentOwner"
              v-model="documentUploadFields.owner"
              class="form-select form-select-lg"
            >
              <option value="" disabled>Select Owner</option>
              <option
                v-for="(u, idx) in ownerList"
                :key="idx"
                :value="`${u.firstName} ${u.lastName}`"
              >
                {{ `${u.firstName} ${u.lastName}` }}
              </option>
            </select>
          </div>

          <div class="col-12 col-md-6 mt-2">
            <label for="expiry-date">Expiry Date</label>
            <input
              id="expiry-date"
              type="text"
              class="form-control"
              v-model="documentUploadFields.expiryDate"
              onfocus="(this.type='date')"
              onblur="(this.type='text')"
              placeholder="Select a date"
              maxlength="30"
            />
            <span class="d-block errorClass" v-if="documentValidationsError[1]">
              Please enter a future date
            </span>
          </div>
          <div class="col-12 col-md-6 mt-2">
            <label for="expiry-date">Expected Completion Date</label>
            <input
              id="expiry-date"
              type="text"
              class="form-control"
              v-model="documentUploadFields.ExpectedCompletionDate"
              onfocus="(this.type='date')"
              onblur="(this.type='text')"
              placeholder="Select a date"
              maxlength="30"
            />
            <span class="d-block errorClass" v-if="documentValidationsError[1]">
              Please enter a future date
            </span>
          </div>
          <div class="col-12 col-md-6 mt-2">
            <label > {{ $t("navigations.artifact") }}</label>
            <select
              class="form-control"
              name="account"
              v-model="selectedArtifact"
            >
              <option value="" disabled>Select Artifact</option>

              <option
                v-for="Artifact in Artifacts"
                :key="Artifact.artifactId"
                :value="Artifact.artifactId"
              >
                {{ Artifact.artifactName }}
              </option>
            </select>
          </div>

          <div class="col-12 mt-2">
            <label for="description">Description</label>
            <textarea
              id="description"
              class="form-control"
              maxlength="250"
              v-model.trim="documentUploadFields.description"
              placeholder="Enter description"
            ></textarea>
          </div>

          <div class="col-12 mt-2">
            <label for="changesHistory">Changes History</label>
            <textarea
              id="changesHistory"
              class="form-control"
              maxlength="250"
              v-model.trim="documentUploadFields.changesHistory"
              placeholder="Enter changes history"
            ></textarea>
          </div>

          <div class="col-12 mt-2">
            <input
              ref="fileInput"
              id="upload-file-input"
              type="file"
              class="form-control d-none my-2 my-md-0"
              accept=".xls,.xlsx,.jpg,.jpeg,.png,.pdf,.docx,.doc"
              @change="previewFiles"
              multiple
            />
            <div
              v-for="(f, idx) in list"
              :key="`${f.name}-${idx}`"
              class="input-group"
            >
              <div class="listfile breakWord">
                <a>
                  {{ f.name }}
                  <i class="fa fa-close" @click.prevent="removefile(idx)"></i>
                </a>
              </div>
            </div>
            <span class="errorClass" v-if="documentValidationsError[2]">
              Please upload a file
            </span>
          </div>
        </div>

        <!-- Actions -->
        <div class="d-flex justify-content-end mt-2">
          <button
            class="browser-btn py-1 px-3 mr-2"
            type="button"
            @click="browse"
          >
            <p class="mb-0">{{ $t("navigations.browse") }}</p>
          </button>

          <button
            type="button"
            class="save_btn py-1 px-3 position-relative"
            :disabled="loadingDocUpload"
            :class="{ 'disabled-btn-cls': loadingDocUpload }"
            @click="submitFile"
          >
            <div
              class="toc-loader position-absolute"
              :class="{
                'opacity-0': !loadingDocUpload,
                'opacity-1': loadingDocUpload,
              }"
            >
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class="loading-btn-img"
                alt="Waiting for login"
              />
            </div>
            <p
              class="mb-0"
              :class="{
                'opacity-1': !loadingDocUpload,
                'opacity-0': loadingDocUpload,
              }"
            >
              {{ $t("navigations.save") }}
            </p>
          </button>
        </div>
      </div>
    </template>
  </customModal>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import store from "../../store";
import customModal from "../customModal/customModal.vue";
import jwt_decode from "jwt-decode";

export default {
  name: "UploadDocumentModal",
  components: { customModal },

  props: {
    visible: { type: Boolean, default: false },
    documentEdit: { type: Boolean, default: false },
    selectedDocument: { type: String, default: "" },
    version: { type: [String, Number], default: "" },
    artifactId: { type: String, default: "" },
    siteCode: {
      type: String,
      default: "",
    },
    documentType: { type: String, default: "" },
  },

  data() {
    return {
      // local state
      siteid: "",
      ownerList: [],
      createdfolderid: "",
      documentUploadFields: {
        expiryDate: "",
        description: "",
        changesHistory: "",
        owner: "",
        ExpectedCompletionDate: ""
      },
      list: [],
      azuredata: { Document: [] },
      documentValidationsError: [false, false, false],
      docTitle: "",
      docVersion: "",
      loadingDocUpload: false,
      documentLoader: false,
      baseurl: process.env.VUE_APP_Service_URL,
      selectedArtifact: "",
      Artifacts: [],
      currentUser: "",
    };
  },
  async mounted() {
    this.getsiteid();
    this.getArtifacts();
    this.getStudyBasedUsers();
    console.log("artifact id = ", this.artifactId);
    console.log("document type = ", this.documentType);
    //this.getreviewers();
  },
  watch: {
    // Reset every time modal opens
    visible(val) {
      if (val) {
        this.resetLocal();
        // default owner if empty
        if (!this.documentUploadFields.owner && this.currentUser) {
          this.documentUploadFields.owner = this.currentUser;
        }
        if (this.documentEdit) {
          this.fetchDocumentDetails();
        }
      }
    },
  },

  methods: {
    handleClose() {
      this.$emit("uploadlibactive");
      this.resetLocal();
    },
    async getStudyBasedUsers(type) {
      const idtoken = store.getters.getIdToken;
      //  let useremail = jwt_decode(idtoken).email;

      //  console.log("user email = ",useremail);
      await axios
        .get(
          `${this.baseurl}/account-core/user/getstudybasedusers?studyid=${store.getters.getStudyIs}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.entities && res.data.entities.length !== 0) {
            this.ownerList = res.data.entities.sort((a, b) =>
              a.firstName.localeCompare(b.firstName)
            );
           // console.log("currentUser", this.currentUser);
            this.setCurrentUser(this.ownerList);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async setCurrentUser(data) {
      console.log("logged", data);
      const idtoken = store.getters.getIdToken;
      const userEmail = jwt_decode(idtoken).email.trim();

      const userObject = data.find((item) => item.email?.trim() === userEmail);

      if (userObject) {
        this.currentUser = `${userObject.firstName} ${userObject.lastName}`;
        console.log("current user = ", this.currentUser);
       this.documentUploadFields.owner = this.currentUser;
      } else {
        console.warn(`No user found for email: ${userEmail}`);
        this.currentUser = null; // or fallback to first user if needed
      }
    },

    async getsiteid() {
      const idtoken = store.getters.getIdToken;
      let studyId = store.getters.getStudyIs;

      await axios
        .get(`${this.baseurl}/management/site/getall?studyId=${studyId}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          const found = res.data.find(
            (element) => element.siteCode == this.siteCode
          );
          this.siteid = found.siteID;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async artifactselected() {
      console.log("artifact selected = ", this.selectedArtifact);
      const idtoken = store.getters.getIdToken;
      let studyId = store.getters.getStudyIs;
      let siteid = store.getters.getStorageId;
      let payload = {
        name: this.siteCode,
        parentId: this.selectedArtifact,
        storageId: siteid,
        storageType: "string",
        fileConfiguration: ["string"],
        versionConfiguration: [
          {
            prefix: "string",
            majorVerStart: "string",
            minorVerStart: "string",
            minorVermax: "string",
          },
        ],
        ancestorIds: ["string"],
        studyId: studyId,
      };
      await axios
        .post(`${this.baseurl}/etmf/folder/createsubartifact`, payload, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("retreieve data", response.data);
          this.createdfolderid = response.data.id;
        })
        .catch((err) => {
          console.log("error", err);
          console.log(err.data);
        });
    },
    async getArtifacts() {
      const idtoken = store.getters.getIdToken;
      let studyId = store.getters.getStudyIs;

      await axios
        .get(
          `${this.baseurl}/etmf/folder/getartifact?studyId=${studyId}&zoneName=""`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.Artifacts = res.data;
          
          if (this.artifactId) {
            const found = this.Artifacts.find(
              (a) => a.artifactId === this.artifactId
            );
            if (found) {
              this.selectedArtifact = found.artifactId;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resetLocal() {
      this.documentUploadFields = {
        expiryDate: "",
        description: "",
        changesHistory: "",
        owner: this.currentUser || "",
      };
      this.docTitle = "";
      this.docVersion = "";
      this.azuredata.Document = [];
      this.list = [];
      this.documentValidationsError = [false, false, false];
      this.loadingDocUpload = false;
      this.documentLoader = false;
    },

    browse() {
      this.$refs.fileInput && this.$refs.fileInput.click();
    },

    previewFiles(e) {
      this.azuredata.Document = [];
      this.azuredata.Document.push(e.target.files);
      this.list = [...this.list, ...this.azuredata.Document[0]];
    },

    removefile(idx) {
      this.list.splice(idx, 1);
    },

    async validatedocument() {
      this.documentValidationsError = [false, false, false];

      // if (store.getters.getFolderId.trim() == "") {
      //   this.documentValidationsError[0] = true;
      //   this.loadingDocUpload = false
      // }
      if (this.docVersion.trim() == "") {
        this.documentValidationsError[0] = true;
        this.loadingDocUpload = false
      }

      if (this.azuredata.Document.length === 0 && this.documentEdit == false) {
        this.documentValidationsError[2] = true;
        this.loadingDocUpload = false;
      }
      if (this.documentUploadFields.expiryDate != null) {
        if (new Date(this.documentUploadFields.expiryDate) < new Date()) {
          this.documentValidationsError[1] = true;
          this.loadingDocUpload = false;
        }
      }
      if (this.documentUploadFields.ExpectedCompletionDate != null) {
        if (new Date(this.documentUploadFields.ExpectedCompletionDate) < new Date()) {
          this.documentValidationsError[1] = true;
          this.loadingDocUpload = false;
        }
      }
    },

    async submitFile() {
      if (this.selectedArtifact == "" || this.selectedArtifact == null) {
        alert("Please select artifact");
        return;
      }
      await this.artifactselected();
      const folderId = this.createdfolderid;
      const idtoken = store.getters.getIdToken;
      this.loadingDocUpload = true;
      let vervalue = this.docVersion.toString();
      await this.validatedocument();
      if (!this.documentValidationsError.includes(true)) {
        if (this.documentEdit == false) {
          const uploadPromises = this.list.map(async (eachfiles) => {
            if (eachfiles.size == 0) {
              alert("Blank documents cannot be uploaded");
              this.loadingDocUpload = false;
            } else {
              if (this.docTitle.trim() == "") {
                this.documentUploadFields.title = eachfiles.name;
              }
              if (this.documentUploadFields.owner.trim() == "") {
                this.documentUploadFields.owner = this.currentUser;
              }
              if (this.docTitle.trim() != "") {
                this.documentUploadFields.title = this.docTitle;
              }
              if (vervalue.trim() == "") {
                vervalue = "1";
              }
              const formData = new FormData();
              formData.append(
                "DocumentDescription",
                this.documentUploadFields.description
              );
              formData.append("StudyId", store.getters.getStudyIs);
              formData.append("FolderId", folderId);
              formData.append("SiteId", this.siteid);
              formData.append("File", eachfiles); // this is critical
              formData.append("Owner", this.documentUploadFields.owner);
              formData.append(
                "ExpiryDate",
                this.documentUploadFields.expiryDate
              );
              formData.append(
                "ExpectedCompletionDate",
                this.documentUploadFields.ExpectedCompletionDate? this.documentUploadFields.ExpectedCompletionDate :""
              );
              formData.append("Version", vervalue ? vervalue.trim() : "");
              formData.append(
                "DocumentTitle",
                this.documentUploadFields.title
                  ? this.documentUploadFields.title.trim()
                  : ""
              );
              formData.append(
                "VersionMessage",
                this.documentUploadFields.changesHistory
              );
              formData.append("StorageLocation", "TMF");
              formData.append("FromPage", this.documentType || "");
              return axios.post(
                `${this.baseurl}/etmf/document/uploaddocument`,
                formData,
                {
                  headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "multipart/form-data",
                  },
                }
              );
            }
          });

          this.loadingDocUpload = true;

          try {
            await Promise.all(uploadPromises);
            alert(this.$t("navigations.documents saved successfully"));
            this.handleClose();
          } catch (err) {
            alert(err.message || "Failed to upload one or more documents.");
          } finally {
            this.loadingDocUpload = false;
          }
        } else {
          if (this.azuredata.Document != "") {
            if (
              confirm("Are you sure you want to replace the existing file?")
            ) {
              await axios
                .put(
                  `${this.baseurl}/etmf/document/editdocument`,
                  {
                    documentId: this.selectedDocument,
                    folderId: folderId,
                    SiteId: this.siteid,
                    documentTitle: this.docTitle,
                    documentDescription: this.documentUploadFields.description,
                    changeHistory: this.documentUploadFields.changesHistory,
                    owner: this.documentUploadFields.owner,
                    department: "",
                    catagory: "",
                    standard: "",
                    documentType: "",
                    expiryDate: this.documentUploadFields.expiryDate
                      ? this.documentUploadFields.expiryDate
                      : null,
                    currentVersion: vervalue,
                    isDeleted: false,
                    status: "string",
                    versionMessage: this.documentUploadFields.changesHistory,
                    signers: [
                      {
                        bookmark: "string",
                        signOrder: "string",
                        userId: "string",
                        userEmail: "string",
                        date: "2025-05-27T05:51:56.555Z",
                        signId: "string",
                        reason: "string",
                        userName: "string",
                        isSigned: true,
                        signedDocId: "string",
                      },
                    ],
                    studyId: store.getters.getStudyIs,
                    artifactId: store.getters.getFolderId,
                    effectiveDate: "2025-05-27T05:51:56.555Z",
                    author: "",
                    reviewDate: "2025-05-27T05:51:56.555Z",
                    approvalDate: "2025-05-27T05:51:56.555Z",
                    siteId: "",
                    country: "",
                    language: "",
                    product: "",
                    region: "",
                    fileSize: "",
                    checksum: "",
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + idtoken,
                      "Content-Type": "application/json",
                    },
                  }
                )
                .then((res) => {
                  this.replaceFile();
                  alert("Document updated successfully");
                  this.handleClose();
                  this.loadingDocUpload = false;
                })
                .catch((err) => {
                  this.loadingDocUpload = false;
                });
            } else {
              this.loadingDocUpload = false;
              return;
            }
          } else {
            await axios
              .put(
                `${this.baseurl}/etmf/document/editdocument`,
                {
                  documentId: this.selectedDocument,
                  folderId: folderId,
                  SiteId: this.siteid,
                  documentTitle: this.docTitle,
                  documentDescription: this.documentUploadFields.description,
                  changeHistory: this.documentUploadFields.changesHistory,
                  owner: this.documentUploadFields.owner,
                  department: "",
                  catagory: "",
                  standard: "",
                  documentType: "",
                  expiryDate: this.documentUploadFields.expiryDate
                    ? this.documentUploadFields.expiryDate
                    : null,
                  currentVersion: vervalue,
                  isDeleted: false,
                  status: "",
                  versionMessage: "",
                  signers: [
                    {
                      bookmark: "string",
                      signOrder: "string",
                      userId: "string",
                      userEmail: "string",
                      date: "2025-05-27T05:51:56.555Z",
                      signId: "string",
                      reason: "string",
                      userName: "string",
                      isSigned: true,
                      signedDocId: "string",
                    },
                  ],
                  studyId: store.getters.getStudyIs,
                  artifactId: store.getters.getFolderId,
                  effectiveDate: "2025-05-27T05:51:56.555Z",
                  author: "",
                  reviewDate: "2025-05-27T05:51:56.555Z",
                  approvalDate: "2025-05-27T05:51:56.555Z",
                  siteId: "",
                  country: "",
                  language: "",
                  product: "",
                  region: "",
                  fileSize: "",
                  checksum: "",
                },
                {
                  headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                  },
                }
              )
              .then((res) => {
                alert("Document updated successfully");
                this.handleClose();
                this.loadingDocUpload = false;
              })
              .catch((err) => {
                this.loadingDocUpload = false;
              });
          }
        }
      }
    },

    async replaceFile(versionStr) {
      const idtoken = store.getters.getIdToken;
      const formData = new FormData();

      for (let i = 0; i < this.azuredata.Document[0].length; i++) {
        formData.append("File", this.azuredata.Document[0][i]);
      }
      formData.append("DocumentId", this.selectedDocument);
      formData.append("SiteId", this.siteid);
      formData.append("ExpiryDate", this.documentUploadFields.expiryDate || "");
      formData.append(
        "VersionMessage",
        this.documentUploadFields.changesHistory || ""
      );
      formData.append("Version", (versionStr || "1").toString());
      formData.append("StudyId", store.getters.getStudyIs);

      await axios.post(`${this.baseurl}/etmf/document/updatefile`, formData, {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "multipart/form-data",
        },
      });
    },

    async fetchDocumentDetails() {
      if (!this.selectedDocument) return;
      this.documentLoader = true;
      const idtoken = store.getters.getIdToken;
      try {
        const url = `${
          this.baseurl
        }/etmf/document/getdocumentdetails?documentId=${this.selectedDocument}${
          this.version ? `&version=${this.version}` : ""
        }`;
        const { data } = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });

        // hydrate fields
        this.docTitle = data.documentTitle || "";
        this.docVersion = data.latestVersion || "";
        this.documentUploadFields.description = data.documentDescription || "";
        this.documentUploadFields.owner = data.owner || this.currentUser || "";
        this.documentUploadFields.expiryDate = data.expiryDate
          ? data.expiryDate.slice(0, 10)
          : "";
        this.documentUploadFields.changesHistory = data.changeHistory || "";
      } catch (e) {
        // swallow
      } finally {
        this.documentLoader = false;
      }
    },
  },
};
</script>

<style scoped>
.browser-btn {
  border: 1px solid #e7eaec;
  background-color: #e7eaec;
  border-radius: 0.25rem;
}
.errorClass {
  color: #d9534f;
  font-size: 0.85rem;
}
.opacity-0 {
  opacity: 0;
}
.opacity-1 {
  opacity: 1;
}
</style>
